const sessions = new Map();

// A topic player replaces the Redux queue, while each history entry still
// represents its own player. Keep its parent queue in memory so browser Back
// can recover it without changing the behavior of shared URLs or refreshes.
export const savePreviewViewerSession = (location, queue, previewId, position) => {
    if (!location?.key || !Array.isArray(queue?.previewsInfo)) return;
    const preview = queue.previewsInfo.find(item => item.id === previewId);
    if (!preview) return;
    const audio = document.getElementById('audio');
    const currentPosition = position ?? (audio?.src === preview.mp3URL ? audio.currentTime : 0);
    sessions.set(location.key, {
        queue: { ...queue, previewsInfo: queue.previewsInfo.slice(), initialPreviewId: previewId },
        previewId,
        position: Number.isFinite(currentPosition) ? Math.max(0, currentPosition) : 0,
    });
};

export const getPreviewViewerSession = (location) => (
    location?.pathname === '/previews' || location?.pathname?.startsWith('/preview/')
        ? sessions.get(location.key) : undefined
);

export const clearPreviewViewerSessions = () => sessions.clear();
